export const removeDuplicatesObjectFromArray = (array?: Record<string, unknown>[]) =>
  array?.filter(
    (v, i, a) => a.findIndex((t) => JSON.stringify(t) === JSON.stringify(v)) === i,
  );
